import { Button, Group, TextInput } from '@mantine/core'
import { useForm } from '@mantine/form'
import { FormattedMessage, useIntl } from 'react-intl'
import { isAlphanumericWithSpaces } from '@/utils/validation/helpers'

export type FormValues = {
  appName: string
}

type UpdateApplicationFormProps = {
  appName: string
  onCancel: () => void
  onSubmit: (formValues: FormValues) => void
}

export const UpdateApplicationForm = ({
  appName,
  onCancel,
  onSubmit
}: UpdateApplicationFormProps) => {
  const intl = useIntl()

  const form = useForm({
    initialValues: {
      appName
    },

    validate: {
      appName: (value) => {
        if (!value) return intl.formatMessage({ id: 'apps.appName.required' })
        if (!isAlphanumericWithSpaces(value))
          return intl.formatMessage({ id: 'apps.appName.invalidChars' })
        return null
      }
    }
  })

  return (
    <form noValidate onSubmit={form.onSubmit((values) => onSubmit(values))}>
      <TextInput
        label={intl.formatMessage({ id: 'apps.appName' })}
        mb="xl"
        autoFocus
        data-autofocus // required for auto focus inside the modal
        {...form.getInputProps('appName')}
      />

      <Group justify="end">
        <Button miw={120} variant="default" onClick={onCancel}>
          <FormattedMessage id="cancel" />
        </Button>

        <Button type="submit">
          <FormattedMessage id="apps.updateApp" />
        </Button>
      </Group>
    </form>
  )
}
